import { StyleSheet } from 'react-native';
import CardPatternSvg from 'assets/images/card-pattern.svg';
import Colors from 'src/core/utils/Colors';

interface Props {
	color?: string;
}

// The artwork is a wide, shallow band, so it is scaled to cover and cropped: stretching it to the
// card box squashed the waves on anything taller than it.
const CardPattern = ({ color = Colors.white }: Props) => (
	<CardPatternSvg
		color={color}
		height="100%"
		pointerEvents="none"
		preserveAspectRatio="xMidYMid slice"
		style={styles.pattern}
		width="100%"
	/>
);

const styles = StyleSheet.create({
	pattern: {
		...StyleSheet.absoluteFill,
	},
});

export default CardPattern;
